import React from 'react';
import { AlertCircle, CheckCircle, Info, AlertTriangle, X } from 'lucide-react';

const TONES = {
  error: { box: 'bg-red-50 border-red-200 text-red-800', Icon: AlertCircle },
  warning: { box: 'bg-amber-50 border-amber-200 text-amber-900', Icon: AlertTriangle },
  success: { box: 'bg-green-50 border-green-200 text-green-800', Icon: CheckCircle },
  info: { box: 'bg-blue-50 border-blue-200 text-blue-800', Icon: Info },
};

/** Inline message. `details` renders a list (e.g. Excel rows with errors). */
export default function Alert({ tone = 'error', title, children, details, onClose, className = '' }) {
  const { box, Icon } = TONES[tone] || TONES.error;
  return (
    <div role={tone === 'error' ? 'alert' : 'status'} className={`rounded-md border p-3 text-sm ${box} ${className}`}>
      <div className="flex gap-2">
        <Icon className="mt-0.5 h-4 w-4 flex-shrink-0" aria-hidden="true" />
        <div className="flex-1 space-y-1">
          {title && <p className="font-medium">{title}</p>}
          {children && <div>{children}</div>}
          {Array.isArray(details) && details.length > 0 && (
            <ul className="list-disc space-y-0.5 pl-5">
              {details.map((d, i) => (
                <li key={i}>{typeof d === 'string' ? d : JSON.stringify(d)}</li>
              ))}
            </ul>
          )}
        </div>
        {onClose && (
          <button type="button" onClick={onClose} aria-label="Skrýt zprávu" className="rounded p-0.5 hover:bg-black/5">
            <X className="h-4 w-4" />
          </button>
        )}
      </div>
    </div>
  );
}
